import { render, staticRenderFns } from "./operationheader.vue?vue&type=template&id=086b97d8"
import script from "./operationheader.vue?vue&type=script&lang=js"
export * from "./operationheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports